/** @param {number} n */
function pad2(n) {
  return String(n).padStart(2, "0");
}

/**
 * Local date/time safe for Windows filenames, e.g. `2026-05-29_02-30-45-PM`.
 * @param {Date} [date]
 */
export function formatLocalTimestampForFilename(date = new Date()) {
  const y = date.getFullYear();
  const mo = pad2(date.getMonth() + 1);
  const d = pad2(date.getDate());
  const hours24 = date.getHours();
  const ampm = hours24 >= 12 ? "PM" : "AM";
  let hours12 = hours24 % 12;
  if (hours12 === 0) hours12 = 12;
  const h = pad2(hours12);
  const mi = pad2(date.getMinutes());
  const s = pad2(date.getSeconds());
  return `${y}-${mo}-${d}_${h}-${mi}-${s}-${ampm}`;
}

/**
 * Default ZIP name for bulk OneDrive document downloads.
 * @param {Date} [date]
 */
export function buildOneDriveBulkDownloadZipFilename(date = new Date()) {
  return `OneDrive-documents-${formatLocalTimestampForFilename(date)}.zip`;
}
